<template>

	<div class="services-grid container-fluid theme-white">
		
		<TitleHeader :subtitle="subtitle" :title="title"></TitleHeader>
		
		<div class="container">
			
			<ul class="services" v-if="services">
				<li :key="service.id" v-for="service in services">
					<a v-if="service.cta" :href="service.cta.linkURL">
						<div class="hover-background" :style="'background-image:url(' + service.hoverBackgroundImage + ');'"></div>
						<header>
							<div class="frame">
								<img class="icon" :src="service.icon.path" :alt="service.icon.alt">
								<img class="hover-icon" :src="service.hoverIcon.path" :alt="service.hoverIcon.alt">
							</div>
						</header>
						<footer>
							<h3>{{ service.title }}</h3>
							<span class="cta-primary" v-if="service.cta">
								{{service.cta.linkText}}
								<svg version="1.1" class="icon-arrow-right" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 257.6 451.8" xml:space="preserve">
								<path d="M243.4,247.4L57.1,433.7c-11.9,11.9-31.1,11.9-42.9,0c-11.8-11.8-11.8-31.1,0-42.9L179,225.9L14.2,61.1 C2.3,49.2,2.3,30,14.2,18.2C26,6.3,45.2,6.3,57.1,18.2l186.3,186.3c5.9,5.9,8.9,13.7,8.9,21.4C252.3,233.7,249.3,241.5,243.4,247.4 z" />
								</svg>
							</span>
						</footer>
					</a>
				</li>
			</ul>
			<PrimaryButton class="center" v-if="cta" :linkText="cta.linkText" :linkURL="cta.linkURL"></PrimaryButton>
		</div>
	</div>
	
</template>

<script>
	
	import PrimaryButton from '../Global/PrimaryButton.vue';
	import TitleHeader from '../Global/TitleHeader.vue';
	
	export default {
		name: 'ServicesGrid',
		
		props: ['subtitle', 'title', 'services', 'cta'],
		
		components: {
			TitleHeader,
			PrimaryButton
		}
	}
	
</script>